import { type ReactNode, useCallback, useRef, useState, useEffect, JSX } from "react";
import { Container, TitleContainer, Title, Chevron, ContentWrapper, Content } from "./style";

export interface AccordionProps {
  title: string;
  children?: ReactNode;
  startsExpanded?: boolean;
  hasChevron?: boolean;
  infoText?: string;
}

const Accordion = ({ title, children, startsExpanded, hasChevron = true, infoText }: AccordionProps): JSX.Element => {
  const [isExpanded, setExpand] = useState<boolean>(startsExpanded || false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState<number>(0);

  useEffect(() => {
    if (!isExpanded) {
      setContentHeight(0);
    } else {
      if (contentRef.current) {
        setContentHeight(contentRef.current.scrollHeight);
      }
    }
  }, [isExpanded]);


  const handleExpandToggle = useCallback(() => {
    setExpand(!isExpanded);
  }, [isExpanded]);

  return (
    <Container>
      <TitleContainer isExpanded={isExpanded}>
        <Title onClick={handleExpandToggle}>
          {title}
          <div style={{ display: "flex", alignItems: "center", gap: "10px", fontWeight: "400" }}>{infoText}{hasChevron && <Chevron direction={isExpanded ? "top" : "bottom"} />}</div>
        </Title>
      </TitleContainer>
      <ContentWrapper maxHeight={contentHeight}>
        <Content ref={contentRef}>{children}</Content>
      </ContentWrapper>
    </Container>
  );
};


export default Accordion;

